import { Box } from '@mui/material';

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function Main(props: Props) {
  return (
    <Box component={'main'} sx={(theme) => ({
      marginTop: '100px',
      flexGrow: 1,
      backgroundColor: theme.palette.grey[900],
    })}>
      {props.children}
    </Box>
  );
}